import { Alert, Snackbar } from '@mui/material'
import { useCRMStore } from '@/store/crm/crmStore'

/** Success / error feedback for CRM actions (reminder, delete, save, …). */
const CrmToast = () => {
  const { toast, closeToast } = useCRMStore()
  return (
    <Snackbar
      open={toast.open}
      autoHideDuration={4000}
      onClose={(_, reason) => {
        if (reason !== 'clickaway') closeToast()
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={closeToast}
        severity={toast.severity}
        variant="filled"
        dir="rtl"
        sx={{ fontFamily: 'Rubik, sans-serif', gap: 1 }}
      >
        {toast.message}
      </Alert>
    </Snackbar>
  )
}

export default CrmToast
